// React Imports
import {useState, useEffect} from "react";
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
} from '@mui/x-data-grid';
import {DataGridPro} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import {
    Drawer,
    Stack,
} from "@mui/material";
import Typography from "@mui/material/Typography";

// App Imports
import {getStakeholderListObligationData} from "../../../ExternalData/StakeholderList/StakeholderListClient";
import {changeObligationHierarchy} from "../obligationHierarchySlice";


// main function
export default function WorkIssuanceObligationStakeholderListGrid() {


    // ****************** BEGIN STATES ****************************

    const [stakeholderListData, setStakeholderListData] = useState([]);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorCdpvId = useSelector((state) => state.obligationHierarchySlc.value.cdpvId);
    const selectorDataPointName = useSelector((state) => state.obligationHierarchySlc.value.dataPointName);
    const selectorDisplayAmount = useSelector((state) => state.obligationHierarchySlc.value.displayValue);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchStakeholderListData = () =>
        getStakeholderListObligationData(selectorCdpvId)

            .then(data => {
                console.log(data);
                setStakeholderListData(data);
                console.log("This is my data used for the grid rows...");
                console.log(stakeholderListData);
            })

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        console.log("My stakeholderList grid should have displayed...");
        fetchStakeholderListData();
    }, [useSelector((state) => state.obligationHierarchySlc.value.stakeholderListGridOpen)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    const handleClose = () => {
        dispatchData(changeObligationHierarchy({stakeholderListGridOpen: false}));
    };


    function closeStakeholderListDataDrawer() {
        dispatchData(changeObligationHierarchy({stakeholderListGridOpen: false}));
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN COLUMNS ***************************

    const columns = fetchStakeholderListData => [
        {    field: 'id',
            headerName: 'ID',
            sortable: true,
            width: 60,
        },

        {    field: 'fileId',
            headerName: 'File ID',
            sortable: true,
            width: 180,
        },
        {
            field: 'recordId',
            headerName: 'Record ID',
            sortable: true,
            width: 60,
        },
        {
            field: 'productId',
            headerName: 'Product ID',
            sortable: true,
            width: 100,
        },
        {
            field: 'productName',
            headerName: 'Product Name',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            // editable: true,
            width: 300,
        },
        {
            field: 'episodeName',
            headerName: 'Episode Name',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            // editable: true,
            width: 250,
        },
        {
            field: 'seriesExternalId',
            headerName: 'Series ID',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 80,

        },
        {
            field: 'seriesName',
            headerName: 'Series Name',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 250,

        },

        {
            field: 'seasonExternalId',
            headerName: 'Season ID',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            // editable: true,
            width: 80,
        },
        {
            field: 'season',
            headerName: '#',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            // editable: true,
            width: 40,
        },
        {
            field: 'seasonName',
            headerName: 'Season Name',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            // editable: true,
            width: 250,
        },

        {
            field: 'guild',
            headerName: 'Guild',
            sortable: true,
            width: 60,
        },
        {
            field: 'fsoId',
            headerName: 'FSO ID',
            sortable: true,
            width: 60,
        },
        {
            field: 'fsoTaxId',
            headerName: 'FSO Tax Id',
            sortable: true,
            width: 80,
        },
        {
            field: 'fsoFirstName',
            headerName: 'FSO First Name',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'fsoLastName',
            headerName: 'FSO Last Name',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'fsoSuffix',
            headerName: 'FSO Suffix',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'contractedPartyId',
            headerName: 'Contracted Party ID',
            sortable: true,
            width: 150,
        },
        {
            field: 'contractedPartyTaxId',
            headerName: 'Contracted Party Tax Id',
            sortable: true,
            width: 150,
        },
        {
            field: 'contractedPartyFirstName',
            headerName: 'Contracted Party First Name',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'contractedPartyLastName',
            headerName: 'Contracted Party Last Name',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'contractedPartySuffix',
            headerName: 'Contracted Party Suffix',
            sortable: true,
            // editable: true,
            width: 150,
        },
        {
            field: 'contractedPartyCompanyName',
            headerName: 'Contracted Party Company',
            sortable: true,
            // editable: true,
            width: 150,
        },
        {
            field: 'payeeId',
            headerName: 'Payee ID',
            sortable: true,
            width: 150,
        },
        {
            field: 'payeeTaxId',
            headerName: 'Payee Tax Id',
            sortable: true,
            width: 150,
        },
        {
            field: 'payeeFirstName',
            headerName: 'Payee First Name',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'payeeLastName',
            headerName: 'Payee Last Name',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'payeeSuffix',
            headerName: 'Payee Suffix',
            sortable: true,
            // editable: true,
            width: 150,
        },
        {
            field: 'payeeCompanyName',
            headerName: 'Payee Company',
            sortable: true,
            // editable: true,
            width: 150,
        },
        {
            field: 'jobCode',
            headerName: 'Job Code',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'contractLength',
            headerName: 'Contract Length',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'contractDate',
            headerName: 'Contract Date',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'compensation',
            headerName: 'Compensation',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'pensionedCompensation',
            headerName: 'Pensioned Compensation',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'scaleCompensation',
            headerName: 'Scale Compensation',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'overtimeCompensation',
            headerName: 'Overtime Compensation',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'premiumOvertimeCompensation',
            headerName: 'Premium Overtime Compensation',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'wardrobeCompensation',
            headerName: 'Wardrobe Compensation',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'allowances',
            headerName: 'Allowances',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'penalties',
            headerName: 'Penalties',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'additFringedCompensation',
            headerName: 'Addit Fringed',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'advance',
            headerName: 'Advance',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'advance2',
            headerName: 'Advance 2',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'workBeginDate',
            headerName: 'Work Begin Date',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'daysWorked',
            headerName: 'Days Worked',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'guaranteedDays',
            headerName: 'Guar. Days',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'taxingLocation',
            headerName: 'Taxing Location',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'participant',
            headerName: 'Participant',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'guildEquivalent',
            headerName: 'Guild Equivalent',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'note1',
            headerName: 'Note 1',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'note2',
            headerName: 'Note 2',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'note3',
            headerName: 'Note 3',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'createdOn',
            headerName: 'createdOn',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'createdBy',
            headerName: 'createdBy',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'lastModifiedOn',
            headerName: 'lastModifiedOn',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'lastModifiedBy',
            headerName: 'lastModifiedBy',
            description: '',
            width: 100,
            hide: true
        },

    ];

    // *************** END COLUMNS *******************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>

                    <GridToolbarColumnsButton />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

    // ****************** END TOOLBAR ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>

            <Drawer sx={{height: "100%", width: 1600}}
                    anchor='right'
                // open={true}
                    open={useSelector((state) => state.obligationHierarchySlc.value.stakeholderListGridOpen)}
                // initialState={{open: false}}
                    onClose={closeStakeholderListDataDrawer}
            >
                <Box>
                    <br/>
                    <h2 style={{paddingLeft: 19, cursor: 'pointer'}} onClick={() => handleClose()}>Cast List Data</h2>
                    <br/>
                    < Stack direction="row" spacing={2}>
                    <Typography sx={{fontWeight: 'bold', pl: 3}}>Data Point</Typography>
                        <Typography >{selectorDataPointName}: {selectorDisplayAmount}</Typography>
                    </Stack>
                    <Box sx={{ pl: 2}}>
                    <DataGridPro

                        style={{height:800, width: 1000, pl: 2}}
                        aria-label={"StakeholderListDataDrawerGrid"}
                        rows={stakeholderListData}
                        disableDensitySelector={true}
                        disableColumnSelector={true}

                        columns={columns(fetchStakeholderListData)}

                        density={"compact"}
                        pageSize={20}
                        rowsPerPageOptions={[20]}

                        rowThreshold={0}

                        components={{
                            Toolbar: CustomToolbar,
                        }}

                    />
</Box>
                </Box>
            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}




